module.exports = __webpack_public_path__ + "static/img/10.12a78d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/10.png
// module id = WHSM
// module chunks = 0